import LaunchIcon from '@mui/icons-material/Launch';
import { BoxProps, Button } from '@mui/material';
import { ButtonType } from '../types/enums';
import { redirectToExternalUrl } from '../utils/ATCOUtils';

type ATCOButtonProps = BoxProps & {
    type: ButtonType;
    text: string;
    altText?: string;
    url?: string;
    urlExternal?: boolean;
    endIcon?: JSX.Element;
};

const ATCOButton: React.FC<ATCOButtonProps> = (props: ATCOButtonProps) => {
    const { type, text, altText = text, url, urlExternal, endIcon, sx } = props;

    const btnClickHandler = (): void => {
        if (!url) return;
        const newUrl = url.toLowerCase().includes('.pdf') ? url.replace(/(.html)/g, '') : url;

        if (urlExternal) {
            redirectToExternalUrl(newUrl, urlExternal);
        } else {
            window.location.href = newUrl;
        }
    };

    return (
        <Button data-dest-url={url} variant={type} sx={sx} aria-label={altText} onClick={btnClickHandler} endIcon={(endIcon || urlExternal) && <LaunchIcon />}>
            {text}
        </Button>
    );
};

export default ATCOButton;
